import { render } from "./trader-detail.vue?vue&type=template&id=73fc1ec7"
import script from "./trader-detail.vue?vue&type=script&lang=js"
export * from "./trader-detail.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__